var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ed-empresa',{key:_vm.$root.$session.versao,attrs:{"intCadastroGeralId":_vm.$route.params.intId,"intTipoCadastroGeralId":300}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }